import React from 'react';
import { close_icon, dark_close, exclametryred, missing_error } from '../../assets/images';
import { dsButtonPrimary, joinButtonClasses } from '../../utils/buttonStyles';

const FailModal = ({ title, description, liner, btntext, btnhandler, visible, close, missing = false }) => {
  const modalIcon = <img src={missing ? missing_error : exclametryred} alt='mail_icon' className='inline-block h-14 w-14 my-6' />;
  const closeIcon = <img src={close_icon} alt='close_icon' className='inline-block h-3 w-3' />;

  return (
    <div
    className={`fixed z-20 inset-0 overflow-y-auto ${visible ? '' : 'hidden'}`}
    aria-labelledby='modal-title'  
    aria-modal='true'
  >
    <div className='flex items-end justify-center  text-center sm:block sm:p-0'>
      <div
        className='fixed inset-0 opacity-50 transition-opacity'
        aria-hidden='true'
        style={{backgroundColor : '#000000'}}
        onClick={close}
      >
      </div>
      <span className='sm:inline-block sm:align-middle sm:h-screen' aria-hidden='true'>
        &#8203;
      </span>  
      <div className="inline-block  align-bottom bg-white text-left overflow-hidden shadow-xl transform transition-75 sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full"
      style={{zIndex : 1000, borderRadius : '10px'}}
      >
        <div className="bg-white px-4 sm:p-6">
          <div className='flex flex-row-reverse '>
            <img src={dark_close} alt='closeIcon' className='cursor-pointer' onClick={close} />
          </div>
            <div className='justify-center text-center'>
                {modalIcon}
              <p className='mb-0 text-gray-700 font-semibold text-xl leading-none'>{title}</p>
              <p className='mb-0 mt-6 text-gray-600 text-base'>{description}</p>
              {liner && <p className='mb-0 mt-1 text-gray-600 text-base'>{liner}</p>}
              { btntext && 
              <button className={joinButtonClasses(dsButtonPrimary, 'mt-6 h-11 px-5')} onClick={btnhandler}>
                {btntext}
              </button>
              }
            </div>  
        </div>
      </div>
    </div>
  </div> 
  );
};

export default FailModal;
